import { atom } from "nanostores";

export const $requestId = atom<string | undefined>(undefined);

export const setRequestId = (id: string) => {
  $requestId.set(id);
};

export const clearRequestId = () => {
  $requestId.set(undefined);
};

export const generateRequestId = () => crypto.randomUUID();
